import API from "./../common/api";
import Fetch from "./fetch";

class Vehicle {
	static searchByVin(vin) {
		const url = `${window.cpAdmin.aggregatorUrl}${API.VEHICLE.ALL_SERVICES.replace(API.KEYS.VIN, vin)}`;

		return Fetch.get(url, null, undefined, false);
	}

	static searchByDevice(device) {
		const url = `${API.PREFIX}${API.VEHICLE.ROOT}${API.VEHICLE.DEVICE.replace(API.KEYS.ID, device)}`;

		return Fetch.get(url);
	}

	static async deleteDevice(vin) {
		const url = `${API.PREFIX}${API.VEHICLE.ROOT}${API.VEHICLE.DELETE_DEVICE.replace(API.KEYS.VIN, vin)}`;
		return Fetch.delete(url);
	}
}
export default Vehicle;